import { useEffect, useState } from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from './router/router';
import { useAppDispatch, useAppSelector } from './store/hooks';
import { getTokenFromLocalStorage } from './helpers/localstorage.helper';
import { AuthService } from './services/auth.service';
import { login, logout, setRefreshing } from './store/user/userSlice';
import { removeAllTokens } from './helpers/localstorage.helper';
import { IProfile } from './types/type';
import Spiner from './components/Spiner/Spiner';

function App() {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(true);
  const { isRefreshing } = useAppSelector((state) => state.user);

  const checkAuth = async () => {
    // Сбрасываем состояние refreshing на всякий случай
    dispatch(setRefreshing(false));

    const token = getTokenFromLocalStorage();

    try {
      if (token) {
        const data = await AuthService.getProfile();
        if (data) {
          dispatch(login(data as unknown as IProfile));
        } else {
          dispatch(logout());
          removeAllTokens();
        }
      } else {
        dispatch(logout());
      }
    } catch (error: any) {
      console.error('Ошибка при проверке аутентификации:', error);

      // Проверяем на ошибки связанные с токенами
      const errorMessage = error.message || '';
      if (errorMessage.includes('Invalid token') || errorMessage.includes('Token') || error.response?.status === 401) {
        console.log('Обнаружен недействительный токен, очищаем localStorage');
        removeAllTokens();
      }

      dispatch(logout());
      dispatch(setRefreshing(false));
    } finally {
      setTimeout(() => setLoading(false), 111);
    }
  };

  useEffect(() => {
    checkAuth();
  }, []);

  if (loading) {
    return <Spiner />;
  }

  return <RouterProvider router={router} />;
}

export default App;
